import React, {Component} from 'react'
import FilterType from './FilterType'
import FilterShippingCarrier from './FilterShippingCarrier'
import FilterShippedAt from './FilterShippedAt'
import PropTypes from "prop-types"
import FilterSource from "./FilterSource"

class OrdersReportFilters extends Component {

    render() {
        const {filters, types, onChangeFilters} = this.props

        return (
            <div className="OrdersReportFilters mb-3 pt-3 pl-3 pr-3">
                <div className="d-flex">
                    <FilterType types={types} filters={filters} onChangeFilters={onChangeFilters}/>
                </div>
                <div className="d-flex align-items-center">
                    <FilterShippedAt filters={filters} onChangeFilters={onChangeFilters}/>
                    <FilterShippingCarrier filters={filters} onChangeFilters={onChangeFilters}/>
                    <FilterSource filters={filters} onChangeFilters={onChangeFilters}/>
                </div>
            </div>
        )
    }
}

OrdersReportFilters.propTypes = {
    filters: PropTypes.object.isRequired,
    types: PropTypes.array,
    onChangeFilters: PropTypes.func.isRequired
}

export default OrdersReportFilters
